import React from 'react';
import Icon from '../AppIcon';
import Image from '../AppImage';

const Footer = ({ onManageCookies }) => {
  return (
    <footer className="bg-card border-t border-border py-12">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="md:col-span-2">
            <div className="flex items-center space-x-3 mb-4">
              <div className="w-10 h-10 flex items-center justify-center">
                <Image 
                  src="/logo.png"
                  alt="Manica Solutions Logo"
                  className="w-10 h-10 object-contain"
                />
              </div>
              <div>
                <h3 className="text-lg font-bold text-gradient-brand">Manica Solutions</h3>
                <p className="text-sm text-text-secondary">Digital Transformation Architects</p>
              </div>
            </div>
            <p className="text-text-secondary mb-4 max-w-md">
              We architect digital transformation through expert software development, 
              turning complex business challenges into elegant, scalable solutions.
            </p>
            <div className="flex space-x-4">
              <a href="https://github.com/ManicaSolutions" className="text-text-secondary hover:text-secondary transition-colors">
                <Icon name="Github" size={20} />
              </a>
              <a href="https://x.com/ManicaSolutions" className="text-text-secondary hover:text-secondary transition-colors">
                <Icon name="Twitter" size={20} />
              </a>
              <a href="https://www.facebook.com/ManicaSolutions" className="text-text-secondary hover:text-secondary transition-colors">
                <Icon name="Facebook" size={20} />
              </a>
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-semibold mb-4">Services</h4>
            <ul className="space-y-2 text-sm text-text-secondary">
              <li><a href="/services-deep-dive" className="hover:text-secondary transition-colors">Custom Development</a></li>
              <li><a href="/services-deep-dive" className="hover:text-secondary transition-colors">Digital Transformation</a></li>
              <li><a href="/services-deep-dive" className="hover:text-secondary transition-colors">MVP Development</a></li>
              <li><a href="/services-deep-dive" className="hover:text-secondary transition-colors">Enterprise Integration</a></li>
            </ul>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2 text-sm text-text-secondary">
              <li><a href="/about-ecosystem" className="hover:text-secondary transition-colors">About Us</a></li>
              <li><a href="/contact-consultation" className="hover:text-secondary transition-colors">Contact</a></li>
              <li><a href="/services-deep-dive" className="hover:text-secondary transition-colors">Services</a></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-semibold mb-4">Contact</h4>
            <ul className="space-y-2 text-sm text-text-secondary">
              <li className="flex items-center space-x-2">
                <Icon name="Mail" size={16} />
                <span>sales@manicasolutions.com</span>
              </li>
              <li className="flex items-center space-x-2">
                <Icon name="Phone" size={16} />
                <span>+27 (11) 083-6344</span>
              </li>
              <li className="flex items-center space-x-2">
                <Icon name="MapPin" size={16} />
                <span>Northgate, Randburg, Johannesburg</span>
              </li>
            </ul>
          </div>


        </div>

        <div className="border-t border-border mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-sm text-text-secondary">
            © {new Date().getFullYear()} Manica Solutions. All rights reserved.
          </p>
          <div className="flex space-x-6 mt-4 md:mt-0">
            <a href="/privacy-policy" className="text-sm text-text-secondary hover:text-secondary transition-colors">Privacy Policy</a>
            <a href="/terms-of-service" className="text-sm text-text-secondary hover:text-secondary transition-colors">Terms of Service</a>
            <a href="/cookie-policy" className="text-sm text-text-secondary hover:text-secondary transition-colors">Cookie Policy</a>
            <button onClick={onManageCookies} className="text-sm text-text-secondary hover:text-secondary transition-colors">Manage Cookies</button>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;


